module.exports = __webpack_public_path__ + "public/img/运行.44de98f9.png";